import { render, staticRenderFns } from "./GeneralConfigurationPage.vue?vue&type=template&id=1ad94a06&scoped=true"
import script from "./GeneralConfigurationPage.vue?vue&type=script&lang=js"
export * from "./GeneralConfigurationPage.vue?vue&type=script&lang=js"
import style0 from "./GeneralConfigurationPage.vue?vue&type=style&index=0&id=1ad94a06&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad94a06",
  null
  
)

export default component.exports